module.exports = __webpack_public_path__ + "assets/img/a5687e7e267f8bf0b4f244159399e1d0.png";